import { eWeatherAPIs } from '../../../../interfaces/constants';
import { GeoLocation } from '../../../../classes/geolocation.class';
import { GeolocationService } from '../../../../services/geolocation.service';
import { UpdateService } from '../../../../services/update.service';

export interface RanchBasicMapParams {
	Lat: number;
	Lng: number;
	Zoom: number;
}

export class RanchBasicLocationService {
	public static readonly DEFAULT_MAP_PARAMS: RanchBasicMapParams = {
		// Centered on the western United States by default.
		Lat: 37.195,
		Lng: -116.486,
		Zoom: 5
	};

	public static async getNewRanchMapParams(updateService: UpdateService): Promise<RanchBasicMapParams> {
		const USER_LOCATION_ZOOM = 10;

		if (RanchBasicLocationService._isValidCoordinatePair(
			updateService.currentLocation.lat,
			updateService.currentLocation.lng
		)) {
			return {
				Lat: updateService.currentLocation.lat,
				Lng: updateService.currentLocation.lng,
				Zoom: USER_LOCATION_ZOOM
			};
		}

		try {
			const position = await GeoLocation.getCoordinates();

			if (position.coords && RanchBasicLocationService._isValidCoordinatePair(
				position.coords.latitude,
				position.coords.longitude
			)) {
				updateService.setCurrentLocation(Number(position.coords.latitude), Number(position.coords.longitude));

				return {
					Lat: updateService.currentLocation.lat,
					Lng: updateService.currentLocation.lng,
					Zoom: USER_LOCATION_ZOOM
				};
			}
		} catch (reason) {
			// Fall back when the browser cannot provide location or the user denies access.
		}

		return RanchBasicLocationService.DEFAULT_MAP_PARAMS;
	}

	public static async getWeatherSettingsFromCoordinates(
		latitude: number,
		longitude: number
	): Promise<{ SpatialETAvailable: boolean; WeatherAPI_Id: number }> {
		if (await GeolocationService.isInCalifornia(latitude, longitude)) {
			return {
				SpatialETAvailable: true,
				WeatherAPI_Id: eWeatherAPIs.CIMIS
			};
		}

		if (await GeolocationService.isInHawaiiOrGuam(latitude, longitude)) {
			return {
				SpatialETAvailable: false,
				WeatherAPI_Id: eWeatherAPIs.CROPNET
			};
		}

		if (await GeolocationService.isInArizona(latitude, longitude)) {
			return {
				SpatialETAvailable: false,
				WeatherAPI_Id: eWeatherAPIs.Azmet
			};
		}

		if (await GeolocationService.isInOpenETStates(latitude, longitude)) {
			return {
				SpatialETAvailable: false,
				WeatherAPI_Id: eWeatherAPIs.OpenET
			};
		}

		return {
			SpatialETAvailable: false,
			WeatherAPI_Id: eWeatherAPIs.Invalid
		};
	}

	private static _isValidCoordinatePair(lat: number, lng: number): boolean {
		return RanchBasicLocationService._isValidCoordinate(lat)
			&& RanchBasicLocationService._isValidCoordinate(lng);
	}

	private static _isValidCoordinate(value: number): boolean {
		return value !== null && value !== undefined && !isNaN(Number(value));
	}
}
